export default "__VITE_ASSET__CGH2ruCj__"